'use client'

import { Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import React from 'react'

import QAImage from '@images/brands/cheongdam/Q&A.png'
import { HeadContainer } from '.'

interface IQA {
  question: string
  answer: string
}

const QAData: IQA[] = [
  {
    question: 'Q. How long do you have to use it to get a result?',
    answer:
      'A. For natural colour, 3~4 days. For darker colours, 5 days is recommended.'
  },
  {
    question: 'Q. Can you use it on dyed hair?',
    answer:
      'A. Black Change Shampoo is dye functional shampoo reported to MFDS, giving gradual dyeing to dyed and discoloured hair.'
  },
  {
    question: 'Q. Do you need to rinse with normal shampoo after use?',
    answer:
      'A. Black Change Shampoo has a cleaning effect; you do not have to use another shampoo separately.'
  },
  {
    question: 'Q. How long does one bottle of shampoo last?',
    answer:
      'A. It can be used about 10 times, but it depend on how much you use and the hair density and length.'
  },
  {
    question: 'Q. Can you choose the colour?',
    answer:
      'A. If you want a natural and polished colour, Natural Brown is recommended. If you prefer a darker colour, Dark Brown is recommended.'
  },
  {
    question: 'Q. How long does it last?',
    answer:
      'A. The colour last for 2 weeks ~ 1 months, depending on the hair type.'
  },
  {
    question: 'Q. Does it stain hands or pillow?',
    answer:
      'A. Not after the hair is dried, but if you leave it on too long during shampoo, the colour may get on your skin. We recommend you to clean your hand while you leave the shampoo on your hair.'
  },
  {
    question: 'Q. Can you use it on sensitive scalp?',
    answer:
      'A. Black Change Shampoo has passed the sensitive skin hypoallergenic test and scalp hypoallergenic test.'
  },
  {
    question: 'Q. Can pregnant women use it?',
    answer:
      'A. Consult with your doctor before use. If you have experienced abnormal skin reaction, trouble, etc., for using other dyeing products, test before fully using the product.'
  }
]

const QAItem = ({ qa }: { qa: IQA }) => {
  return (
    <VStack data-aos="fade-up" alignItems={'start'} gap={4}>
      <Box
        textStyle={'qaQuestion'}
        color={'white'}
        bg={'#b8b7b7'}
        py={2}
        px={5}
        borderRadius={'20px'}
      >
        {qa.question}
      </Box>
      <Box>
        <Box textStyle={'qaAnswer'} ml={5}>
          {qa.answer}
        </Box>
      </Box>
    </VStack>
  )
}

const QA = () => {
  return (
    <VStack my={10} gap={4}>
      <Image
        data-aos="fade-up"
        src={QAImage}
        alt="qa"
        sizes="100vw"
        style={{
          width: '100%',
          height: 'auto'
        }}
      />
      <HeadContainer>
        <VStack data-aos="fade-up" borderBottom={'3px solid #686868'} mt={3}>
          <Text textAlign="center" textStyle={'qaTitle'}>
            Ellixi Black Change Shampoo
          </Text>
          <Text textStyle="qaTitleQA">Q&A</Text>
        </VStack>
        <VStack alignItems={'start'} my={5} gap={5}>
          {QAData.map((data, i) => {
            return <QAItem qa={data} key={i} />
          })}
        </VStack>
      </HeadContainer>
    </VStack>
  )
}

export default QA
